(() => {
  if (window.cistaPolicyDialogReady) return;
  const dialog = document.getElementById('CistaPolicyDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  window.cistaPolicyDialogReady = true;
  const heading = dialog.querySelector('#CistaPolicyTitle');
  const content = dialog.querySelector('[data-policy-content]');
  const fullLink = dialog.querySelector('[data-policy-full]');
  let trigger;
  let drawer;
  let previousOverflow;
  let backdropPress = false;
  let consumeEscapeRelease = false;

  // Returns and warranty share one merchant policy. Select a section only when
  // its explicit heading exists; otherwise retain the complete policy unchanged.
  function selectPolicySection(kind) {
    if (kind === 'shipping' || !dialog.dataset.warrantyHeading || !dialog.dataset.returnsHeading) return;
    const headings = Array.from(content.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    const normalize = text => text.normalize('NFKC').trim().toLocaleLowerCase(document.documentElement.lang || 'en');
    const warranty = headings.find(node => node.dataset.cistaPolicySection === 'warranty' || normalize(node.textContent) === normalize(dialog.dataset.warrantyHeading));
    const returns = headings.find(node => node.dataset.cistaPolicySection === 'returns' || normalize(node.textContent) === normalize(dialog.dataset.returnsHeading));
    if (!warranty || !returns) return;
    const range = document.createRange();
    if (kind === 'warranty') {
      range.setStartBefore(warranty);
      range.setEndAfter(content.lastChild);
    } else {
      range.setStartBefore(returns);
      range.setEndBefore(warranty);
    }
    content.replaceChildren(range.cloneContents());
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-cista-policy]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const kind = link.dataset.cistaPolicy;
    if (!['shipping', 'returns', 'warranty'].includes(kind)) return;
    const template = document.querySelector(`template[data-cista-policy-template="${kind}"]`);
    if (!template) return;
    event.preventDefault();
    trigger = link;
    drawer = link.closest('cart-drawer.active');
    previousOverflow = document.body.style.overflow;
    heading.textContent = template.dataset.title;
    content.replaceChildren(template.content.cloneNode(true));
    selectPolicySection(kind);
    fullLink.href = link.href;
    if (drawer && typeof removeTrapFocus === 'function') removeTrapFocus();
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    dialog.scrollTop = 0;
    heading.focus({ preventScroll: true });
  });
  dialog.querySelector('[data-policy-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('pointerdown', event => { backdropPress = event.target === dialog; });
  dialog.addEventListener('click', event => {
    if (event.target === dialog && backdropPress) dialog.close();
    backdropPress = false;
  });
  dialog.addEventListener('cancel', () => { consumeEscapeRelease = true; });
  // Focus returns to the drawer before Escape keyup; consume that release so
  // Dawn does not also close the cart underneath the dialog.
  document.addEventListener('keyup', event => {
    if (consumeEscapeRelease && event.key === 'Escape') {
      consumeEscapeRelease = false;
      event.stopPropagation();
    }
  }, true);
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow || '';
    if (drawer?.isConnected && drawer.classList.contains('active') && typeof trapFocus === 'function') {
      const target = trigger?.isConnected ? trigger : drawer.querySelector('.drawer__close');
      trapFocus(drawer.querySelector('.drawer__inner') || drawer, target || drawer);
    } else if (trigger?.isConnected) {
      trigger.focus({ preventScroll: true });
    }
    drawer = null;
  });
})();
